import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import './styles/tokens.css';
import './index.css';
import './styles/global.css';
import './styles/fonts.css';
import './styles/responsive.css';
import App from './App';
import theme from './theme';
import reportWebVitals from './reportWebVitals';

// Polyfill flag emojis for Chrome on Windows
polyfillCountryFlagEmojis();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
